<script>
    // core components
    import CobradorView from "../../viewsERP/Cobrador.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <CobradorView />
    </div>
  </div>